export default __webpack_public_path__ + "user-details-nudge-bg.png";